module.exports = __webpack_public_path__ + "static/media/is_wellness_building.8bf505f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/is_wellness_building.svg
// module id = 1433
// module chunks = 0